export interface IAccountingSyncJobItem {
  targetId: string;
  name: string;
  failureReason?: string;
  processedAt?: Date;
  syncJobId: string;
}
